// @ts-nocheck
import React from 'react';

/**
 * Progress — bar from 0..1 (or pass `percent` 0..100). `tone` switches the
 * fill gradient.
 */
const Progress = ({ value, percent, tone = 'green', height = 8, className = '' }) => {
  const v = typeof percent === 'number' ? percent : (value || 0) * 100;
  const clamped = Math.max(0, Math.min(100, v));
  const fill = tone === 'mixed'
    ? 'linear-gradient(90deg, var(--mov-warn), var(--mov-accent))'
    : tone === 'amber' ? 'var(--mov-warn)'
    : tone === 'red' ? 'var(--mov-danger)'
    : 'var(--mov-accent)';
  return (
    <div
      className={className}
      style={{
        height,
        background: 'var(--mov-paper-2)',
        border: '1px solid var(--mov-line)',
        borderRadius: 999,
        overflow: 'hidden',
      }}
    >
      <span
        style={{
          display: 'block',
          height: '100%',
          width: `${clamped}%`,
          background: fill,
          transition: 'width .3s ease',
        }}
      />
    </div>
  );
};

export default Progress;
